import React from 'react';
import { FaTimes } from 'react-icons/fa';
import '../assets/css/FileViewerModal.css';

const FileViewerModal = ({ isOpen, onClose, fileUrl, fileType, fileName }) => {
  if (!isOpen) return null;

  // Debug log
  console.log('FileViewerModal props:', { fileUrl, fileType, fileName, isOpen });

  return (
    <div className="file-viewer-modal-overlay">
      <div className="file-viewer-modal">
        <div className="file-viewer-header">
          <h3>{fileName}</h3>
          <button onClick={onClose} className="close-button">
            <FaTimes />
          </button>
        </div>
        <div className="file-viewer-content">
          {/* Only show image if fileType is image or fileUrl ends with image extension */}
          {fileType?.startsWith('image/') || (fileType === '' && /\.(png|jpe?g|gif|bmp|webp)$/i.test(fileUrl)) ? (
            <img src={fileUrl} alt={fileName}  style={{ maxWidth: '100%', maxHeight: '100%' }} />
          ) : fileType === 'application/pdf' ? (
            <iframe
              src={fileUrl}
              title={fileName}
              width="100%"
              height="100%"
              style={{ border: 'none' }}
            />
          ) : (
            <div className="unsupported-file">
              This file type cannot be previewed. Please download to view.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FileViewerModal; 